import React from 'react'

export default function wordToPdf(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M26.48 8.08v11.85c-.6-.1-1.2-.2-1.8-.2-4.79-.3-8.88 3.26-9.28 7.9v.99c0 1.09.2 2.27.7 3.26H2.73c-1.1 0-2-.89-2-1.97V2.65c0-1.09.9-1.97 2-1.97h16.76c.5 0 1 .2 1.4.59l4.99 5.13c.4.39.6 1.09.6 1.68Z"
          opacity=".1"
        />
        <path
          fill="currentColor"
          d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9c-4.1 0-7.5 3.3-7.5 7.5s3.3 7.5 7.5 7.5 7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M24.5 30H21c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
        />
        <path
          fill="currentColor"
          d="m26.1 5.9-.3-.3L21.2 1 21 .8c-.5-.5-1.2-.8-1.9-.8H3.2C1.7 0 .4 1.3.4 2.8v26.9c0 1.6 1.3 2.8 2.8 2.8h13.2c-.2-.3-.3-.7-.4-1H3.4c-1.1 0-2-.9-2-2V2.9c0-1 .8-1.8 1.8-1.8h16c.3 0 .7.1.9.4l.5.5 4.2 4.2.7.7c.2.2.3.4.3.7v12.3c.3 0 .6.1.9.1V7.5c0-.6-.2-1.2-.6-1.6Z"
        />
        <path
          fill="currentColor"
          d="M3.09 14.48h20.92Zm0 3.26h20.97ZM13.4 7.75h10.54Zm0 3.08h10.54Z"
        />
        <path
          fill="currentColor"
          d="M24.06 17.24a.5.5 0 0 1 0 1H3.09a.5.5 0 0 1 0-1h20.97Zm-.05-3.26a.5.5 0 1 1 0 1H3.09a.5.5 0 0 1 0-1h20.92Zm-.07-3.65a.5.5 0 1 1 0 1H13.4a.5.5 0 0 1 0-1h10.54Zm0-3.08a.5.5 0 0 1 0 1H13.4a.5.5 0 0 1 0-1h10.54Zm-14.437-4c.388 0 .657.268.657.67v6.016c0 .268-.261.536-.657.536v.008H3.587c-.388 0-.657-.268-.657-.67V3.92c0-.402.26-.67.657-.67h5.916Zm-6.171.803 1.204 5.624h1.13l.878-3.69.884 3.69h1.13l1.2-5.624H8.65l-.735 3.92-.898-3.92h-.943L5.18 7.971l-.74-3.918H3.332Z"
        />
      </svg>
    </div>
  )
}
